import { render, staticRenderFns } from "./EventPropertyGroup.vue?vue&type=template&id=280ecb68&"
import script from "./EventPropertyGroup.vue?vue&type=script&lang=js&"
export * from "./EventPropertyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('280ecb68')) {
      api.createRecord('280ecb68', component.options)
    } else {
      api.reload('280ecb68', component.options)
    }
    module.hot.accept("./EventPropertyGroup.vue?vue&type=template&id=280ecb68&", function () {
      api.rerender('280ecb68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Event/EventPropertyGroup/EventPropertyGroup.vue"
export default component.exports